import "../scss/style.scss";
import { DateTime } from 'luxon';
// Set a global default timezone (e.g., 'America/New_York')
const DEFAULT_TIMEZONE = 'Asia/Qatar';
// At the top of your script, define the base URL.
const API_BASE_URL = 'https://app.gopilatesqatar.com/api';

// Example function for consistent datetime handling
// Get current time in Qatar
export function getNow() {
  return DateTime.now().setZone(DEFAULT_TIMEZONE);
}

// Format example
export function formatQatarDate(date = DateTime.now()) {
  return date.setZone(DEFAULT_TIMEZONE).toFormat('yyyy-MM-dd HH:mm:ss');
}

 
//jQuery 
import $ from 'jquery';
window.jQuery = $;
window.$ = $;

// Popper js
import { createPopper } from '@popperjs/core';

// Bootstrap 
import * as bootstrap from "bootstrap";
// Note: If you want to make bootstrap globally available, e.g. for using `bootstrap.modal`
window.bootstrap = bootstrap;

// Feather icons
import feather from "feather-icons";
window.feather = feather;

// Chart js
import Chart from "chart.js/auto";
window.Chart = Chart;

// Siwper bundle 
import Swiper from 'swiper/bundle';
window.Swiper = Swiper;

// Moments js
import moment from 'moment';
window.moment = moment

// Daterangepicker 
import daterangepicker from 'bootstrap-daterangepicker';
window.daterangepicker = daterangepicker;

// DataTable
import 'datatables.net'
window.dataTables = dataTables;

// DataTable Responsive
import 'datatables.net-responsive'

// Dragula
import dragula from 'dragula';
window.dragula = dragula;

// Dropzone
import Dropzone from "dropzone";
window.Dropzone = Dropzone;

// FullCalendar
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
window.Calendar = Calendar;
window.dayGridPlugin = dayGridPlugin;
window.timeGridPlugin = timeGridPlugin;
window.listPlugin = listPlugin;

// Froala Editor
import FroalaEditor from 'froala-editor'
window.FroalaEditor = FroalaEditor;

// Progressbar min js
import ProgressBar from "progressbar.js"
window.ProgressBar = ProgressBar;

// SmartWizard
import smartWizard from 'smartwizard';
window.smartWizard = smartWizard;

// Lozad
import lozad from 'lozad';
window.lozad = lozad;



// Simplebar
import 'simplebar';


// global js
import './core/functions.js';
import './core/main.js';
import './core/responsive.js';
import './core/color-scheme.js';
import './core/rescalendar.js'
import 'owl.carousel/dist/owl.carousel.min.js';  // Owl Carousel import
// Remove the redirect logic and replace with this:
const tokenKey = "mbAccessToken";
const expiryKey = "mbTokenExpiry";

// Check and update token
async function checkAndFetchToken() {
    const token = localStorage.getItem(tokenKey);
    const expiry = localStorage.getItem(expiryKey);

    // If token exists and is not expired, use it
    if (token && expiry && new Date(expiry) > new Date()) {
        console.log("Token is valid:", token);
        return token;
    }

    // Else, fetch a new token
    try {
      const response = await fetch("https://api.gopilatesqatar.com/mindbody/token", {
          method: "POST"
      });
  
      const data = await response.json();
  
      if (data.AccessToken && data.Expires) {
          localStorage.setItem(tokenKey, data.AccessToken);
          localStorage.setItem(expiryKey, data.Expires);
          console.log("New token saved:", data.AccessToken);
          return data.AccessToken;
      } else {
          console.error("Token fetch failed:", data);
          return null;
      }
  } catch (error) {
      console.error("Token fetch error:", error);
      return null;
  }
}

 

$(document).ready(function() {
    // Check auth status on page load
    checkAuthStatus();
    
    // Tab switching
    $('#login-tab').click(() => showLoginForm());
    $('#register-tab').click(() => showRegisterForm());
    
    // Login handler
    $('#loginBtn').click(handleLogin);
    
    // Register handler
    $('#registerBtn').click(handleRegister);

    // Birthday check
    checkAndPromptBirthday();
  });

  function checkAndPromptBirthday() {
    const clientId = localStorage.getItem('clientId');
    //alert(clientId);
    if (!clientId) return;

    $.ajax({
        url: `${API_BASE_URL}/client/complete-info?client_id=${clientId}`,
        method: 'GET',
        headers: {
            'Accept': 'application/json'
        },
        success: function (res) {
          console.log("Birthday Client Check");
          console.log(res);
            const birthday = res?.Client?.birthday;
            if (!birthday || birthday === null || birthday === '' || birthday === '0000-00-00') {
               // showBirthdayPopup(clientId);
            }
        },
        error: function (xhr) {
            console.error('Error fetching client info:', xhr.responseText);
        }
    });
}

function showBirthdayPopup(userIdentifier) {
    // Append modal only once
    if ($('#birthdayModal').length === 0) {
        $('body').append(`
            <div class="modal fade" id="birthdayModal" tabindex="-1" role="dialog" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
              <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content text-center">
                  <div class="modal-header">
                    <h5 class="modal-title w-100">Additional Information Required</h5>
                  </div>
                  <div class="modal-body">
                    <p class="mb-3">
                      To help us recommend the most suitable Pilates classes for your age and fitness level, we kindly request your date of birth.
                    </p>
                    <input type="date" id="birthdayInput" class="form-control" />
                  </div>
                  <div class="modal-footer justify-content-center">
                    <button type="button" id="saveBirthdayBtn" class="btn btn-primary btn-lg w-100">Submit Birthday</button>
                  </div>
                </div>
              </div>
            </div>
        `);
    }

    const birthdayModal = new bootstrap.Modal(document.getElementById('birthdayModal'), {
        backdrop: 'static',
        keyboard: false
    });

    birthdayModal.show();

    // Save handler
    $('#saveBirthdayBtn').off('click').on('click', function () {
        const birthday = $('#birthdayInput').val();

        if (!birthday) {
            alert('Please enter your birthday.');
            return;
        }

        $.ajax({
            url: `${API_BASE_URL}/update-birthday`,
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({
                user_identifier: userIdentifier,
                birthday: birthday
            }),
            success: function (res) {
                alert('Thank you! Your birthday has been updated successfully.');
                birthdayModal.hide();
            },
            error: function (xhr) {
                console.error('Error updating birthday:', xhr.responseText);
                alert('Failed to update birthday. Please try again.');
            }
        });
    });
}

function showOutdatedLoginModal() {
    // Append modal only once
    if ($('#outdatedLoginModal').length === 0) {
        $('body').append(`
            <div class="modal fade" id="outdatedLoginModal" tabindex="-1" aria-labelledby="outdatedLoginModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header border-0">
                    <h5 class="modal-title w-100 text-center" id="outdatedLoginModalLabel">App Upgrade Alert!</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body text-center">
                    <p>
                      We've upgraded our application with new features. If you encounter any issues with bookings or packages, please contact us immediately.
                    </p>
                    <p class="mb-0">
                      Call us or WhatsApp at: <br/>
                      <a href="tel:+97451777393" class="fw-bold">+974 51777393 </a>
                    </p>
                  </div>
                  <div class="modal-footer justify-content-center border-0">
                    <button type="button" class="btn btn-primary btn-lg w-100" data-bs-dismiss="modal">I Understand</button>
                  </div>
                </div>
              </div>
            </div>
        `);
    }

    // Create a new Bootstrap modal instance and show it
    const outdatedLoginModal = new bootstrap.Modal(document.getElementById('outdatedLoginModal'), {
        backdrop: 'static',
        keyboard: false
    });
    outdatedLoginModal.show();
}

  // Logout button handler
    $(document).on('click', '#logoutBtn', function() {
        // Clear all authentication-related data from localStorage
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('authToken');
        localStorage.removeItem('userData');
        localStorage.removeItem('clientId');
        //localStorage.clear();
        // Redirect to login page or show login form
        window.location.href = 'index.html'; // or your login page
        
        // If you're using the single-page approach from earlier:
        // $('#mainContent').hide();
        // $('#authOverlay').show();
        // showLoginForm();
    });
  
function checkAuthStatus() {
    showOutdatedLoginModal();
    // 1. Define the cutoff date.
    const CUTOFF_DATE = new Date('2024-08-13T00:00:00.000Z');

    // 2. Retrieve both the login status and the logged date.
    const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
    const loggedDate = localStorage.getItem('LoggedDate');

    // 3. Assume the user is not authenticated by default.
    let isAuth = false;
    // const outdatedLoginModal = new bootstrap.Modal(document.getElementById('outdatedLoginModal'));
    // outdatedLoginModal.show();
    // 4. Check if the user's authentication is still valid.
    if (isLoggedIn && loggedDate) {
        const storedDate = new Date(loggedDate);
        if (storedDate >= CUTOFF_DATE) {
            isAuth = true;
        } else {
            // Data is old. Clear localStorage and prepare to show the modal.
            console.log("Login date is too old. Clearing all local storage.");
            // outdatedLoginModal.show();
            localStorage.clear();
        }
    } else {
        // Data is missing. Clear localStorage and prepare to show the modal.
        console.log("Authentication data is incomplete. Clearing all local storage.");
        // outdatedLoginModal.show();
        localStorage.clear();
    }

    // 5. Show or hide content based on the final authentication status.
    if (isAuth) {
        // User is authenticated - show main content.
        $('#authOverlay').hide();
        $('#mainContent').show();
        initializeCalendar();
    } else {
        // User is not authenticated - show auth overlay and the pop-up.
        $('#authOverlay').show();
        $('#mainContent').hide();        
        // Use Bootstrap to show the modal.        
        
    }
}
  
  function showLoginForm() {
    $('#loginForm').show();
    $('#registerForm').hide();
    $('#login-tab').addClass('active');
    $('#register-tab').removeClass('active');
  }
  
  function showRegisterForm() {
    $('#loginForm').hide();
    $('#registerForm').show();
    $('#login-tab').removeClass('active');
    $('#register-tab').addClass('active');
  }
  
  async function handleLogin() {
    const identifier = $('#emailadd').val();
    const password = $('#passwd').val();
  
    $('#loginBtn').html('<span class="spinner-border spinner-border-sm"></span> Logging in...');
  
    try {
      const response = await fetch(`${API_BASE_URL}/login`, {
        method: 'POST',
        credentials: 'include', // for cookies/sessions
         headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                        // 'Authorization': `Bearer ${yourApiToken}` // add this if required
                    },
        body: JSON.stringify({
          login: identifier,
          password: password
        })
      });
  
      const data = await response.json();
      if (response.require_password_reset == 1) {
        showAlert('Please reset your password to proceed with the login. Use the Forgot Password link to reset it.', 'danger');
      }else if (response.ok && data.token) {       
          localStorage.setItem('isLoggedIn', 'true');
          localStorage.setItem('authToken', data.token);
          localStorage.setItem('siteId', 5742446);
          localStorage.setItem('Test', false);
          localStorage.setItem('User-Agent', 'MobileApp');
          localStorage.setItem('Api-Key', '82b0c00f5b804ac0b5ac2e5b2870a3e1');
          localStorage.setItem('userData', JSON.stringify(data.user || data.data));
          localStorage.setItem('clientId', JSON.stringify(data.user.mindbody_client_id));
          localStorage.setItem('mindbodyUserData', JSON.stringify(data.mindbody_client));
          localStorage.setItem('ProfileName', data.user.name);
          localStorage.setItem('name', data.user.name);
          localStorage.setItem('email', data.user.email);
          localStorage.setItem('phone', data.user.phone);
    
          console.log(localStorage.getItem('clientId'));
    
          $('#ProfileName').html(data.user.name);
          $('#authOverlay').hide();
          $('#mainContent').show();
          initializeCalendar();localStorage.setItem('isLoggedIn', 'true');
          localStorage.setItem('authToken', data.token);
          localStorage.setItem('siteId', 5742446);
          localStorage.setItem('Test', false);
          localStorage.setItem('User-Agent', 'MobileApp');
          localStorage.setItem('Api-Key', '82b0c00f5b804ac0b5ac2e5b2870a3e1');
          localStorage.setItem('userData', JSON.stringify(data.user || data.data));
          localStorage.setItem('clientId', JSON.stringify(data.user.mindbody_client_id));
          localStorage.setItem('mindbodyUserData', JSON.stringify(data.mindbody_client));
          localStorage.setItem('ProfileName', data.user.name);
          localStorage.setItem('name', data.user.name);
          localStorage.setItem('email', data.user.email);
          localStorage.setItem('phone', data.user.phone);
    
          console.log(localStorage.getItem('clientId'));
    
          $('#ProfileName').html(data.user.name);
          $('#authOverlay').hide();
          $('#mainContent').show();
          initializeCalendar();
        }        
      else {
        showAlert('Login failed: ' + (data.message || 'Invalid response format'), 'danger');
      }
  
    } catch (error) {
      let errorMsg = 'Server error';
  
      if (error.response && error.response.json) {
        const errData = await error.response.json();
        errorMsg = errData.message || 'Request failed';
      }
  
      showAlert('Login error: ' + errorMsg, 'danger');
    } finally {
      $('#loginBtn').html('Login');
    }
  }
  
  
  async function handleRegister() {
    const firstName = $('#namef').val();
    const lastName = $('#namel').val();
    const email = $('#regEmail').val();
    const phone = $('#phonen').val();
    const password = $('#regPassword').val();
    const confirmPassword = $('#regConfirmPassword').val();
  
    if (password !== confirmPassword) {
      showAlert('Passwords do not match', 'danger');
      return;
    }
  
    const $registerBtn = $('#registerBtn');
    $registerBtn.html('<span class="spinner-border spinner-border-sm"></span> Registering...');
    $registerBtn.prop('disabled', true);
  
    const registrationData = {
      email: email,
      password: password,
      first_name: firstName,
      last_name: lastName,
      phone: phone.replace(/\D/g, ''),
      state: 'CA',
      is_test: true,
      password_confirmation: confirmPassword
    };
  
    try {
      const response = await fetch(`${API_BASE_URL}/register`, {
        method: 'POST',
        //credentials: 'include',
         headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                        // 'Authorization': `Bearer ${yourApiToken}` // add this if required
                    },
        body: JSON.stringify(registrationData)
      });
  
      const data = await response.json();
  
      if (response.ok && data.user) {
        showAlert('Registration successful. Please login using your username and password.', 'success');
        $('#loginOTPSection').show();
        $('#registerSection').hide();
      } else {
        const message = data.message || 'Unknown error';
        showAlert('Registration failed: ' + message, 'danger');
      }
  
    } catch (error) {
      console.log(error);
      let errorMsg = 'Registration error';
      if (error.response && error.response.json) {
        const errData = await error.response.json();
        errorMsg += ': ' + (errData.message || (errData.errors ? Object.values(errData.errors).join(' ') : 'Server error'));
      }
      showAlert(errorMsg, 'danger');
    } finally {
      $registerBtn.html('Sign up');
      $registerBtn.prop('disabled', false);
    }
  }
  
    // Handle successful registration and auto-login
    function handleSuccessfulRegistration(response) {
        localStorage.clear();
        // Store user data
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('authToken', response.token);
        localStorage.setItem('userData', JSON.stringify(response.user));
        localStorage.setItem('clientId', JSON.stringify(response.user.mindbody_client_id));
        console.log("Register Response"+ response);
        alert(localStorage.getItem('clientId'));
        // Hide auth overlay and show main content
        $('#authOverlay').hide();
        $('#mainContent').show();
        
        // Initialize your app components
        initializeCalendar();
        
        // Show success message
        showAlert('Registration successful! Welcome ' + response.user.name, 'success');
      }
    
      // Password visibility toggle
      $('.toggle-password').click(function() {
        const input = $(this).siblings('.form-floating').find('input');
        const icon = $(this).find('i');
        const type = input.attr('type') === 'password' ? 'text' : 'password';
        input.attr('type', type);
        icon.toggleClass('bi-eye bi-eye-slash');
      });
  
  
  function initializeCalendar() {
    const calendarContainer = $("#calendar-container");
    const datePicker = $('#monthYearPicker');
    let chooseddate;
    console.log("Choosed Date" + chooseddate);
    const totalDays = 30;

    // Helper functions
    function getDayOfWeek(date) {
        const daysOfWeek = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
        return daysOfWeek[date.getDay()];
    }

    function formatMonthShort(date) {
        const monthsOfYear = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        return monthsOfYear[date.getMonth()];
    }

    function formatDateInputValue(date) {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
  }

    function build30DayCarousel(startDate) {
        calendarContainer.trigger('destroy.owl.carousel');
        calendarContainer.html('');

        calendarContainer.owlCarousel({
            loop: false,
            nav: false,
            navText: [
                '<i class="fa-solid fa-chevron-left fa-fw"></i>',
                '<i class="fa-solid fa-chevron-right fa-fw"></i>',
            ],
            margin: 10,
            responsive: {
                0: { items: 7 },     // 👈 Show 3 items even on smallest screen
                480: { items: 4 },
                600: { items: 5 },
                800: { items: 6 },
                1000: { items: 7 },
                1200: { items: 7 }
            },
            stagePadding: 10,
            center: false,
            autoWidth: false
        });

        const todayStr = formatDateInputValue(new Date());

        for (let i = 0; i < totalDays; i++) {
            const date = new Date(startDate);
            date.setDate(startDate.getDate() + i);
            const dateString = formatDateInputValue(date);

            const dayCard = $("<div>")
                .addClass("day-card card rounded text-center px-2 py-1")
                .html(
                    "<p class='fw-bold mb-0' style='font-size:0.5rem'>" + getDayOfWeek(date) + "</p>" +
                    "<h4 class='mb-0 '>" + date.getDate() + "</h4>"+ 
                    "<input type='hidden' class='selected_date mb-0 d-none' data-value='" + formatDateInputValue(date) + "'/>"
                )
                .css("cursor", "pointer")
                .data("date", dateString)
                .on("click", function () {
                    calendarContainer.find(".day-card").removeClass("border-success selectedcard");
                    chooseddate = $(this).data("date");
                    $(this).addClass("border-success selectedcard");
                    console.log("Choosed Date:"+chooseddate);
                    PopulateClasses(chooseddate);
                });

            calendarContainer.trigger("add.owl.carousel", [dayCard]);

            // ✅ Auto-select today
            if (dateString === todayStr) {
                dayCard.addClass("border-success selectedcard");
                chooseddate = dateString;
                console.log("Choosed Date:"+chooseddate);
            }
        }

        calendarContainer.trigger("refresh.owl.carousel");
    }

    // ✅ Prevent past date selection
    const today = new Date();
    const todayStr = formatDateInputValue(today);
    datePicker.attr("min", todayStr);
    datePicker.val(todayStr); // Set today's date as default in picker

    // Build calendar
    build30DayCarousel(today);

    // Handle date input change
    datePicker.on('change', function () {
        const selectedDate = new Date($(this).val());
        const selectedStr = formatDateInputValue(selectedDate);
        if (!isNaN(selectedDate) && selectedStr >= todayStr) {
            build30DayCarousel(selectedDate);
        } else {
            alert("You can't select a past date.");
            $(this).val(todayStr);
            build30DayCarousel(today);
        }
    });
    $('#FiltersButton').on('click', function () {      
        //Filters Dropdown      
          $.ajax({
            url: 'https://api.gopilatesqatar.com/api/proxy?url=https://api.mindbodyonline.com/public/v6/staff/staff',
            type: 'GET',
            success: function (response) {
              const staff = response.StaffMembers || [];
              const $dropdown = $('#TrainersDropdown');
              $dropdown.empty(); // clear old options
      
              staff.forEach(member => {
                const option = $('<option></option>')
                  .val(member.Id)
                  .text(member.DisplayName || member.Name || 'Unnamed');
                $dropdown.append(option);
              });
            },
            error: function (xhr, status, error) {
              console.error('Failed to load trainers:', error);
            }
          });       
       
    });
    $('#prev30').on('click', function () {
        const current = new Date($('#monthYearPicker').val());
        current.setDate(current.getDate() - 7);
        const today = new Date();
        if (current < today) {
            $('#monthYearPicker').val(today.toISOString().split("T")[0]);
            build30DayCarousel(today);
        } else {
            $('#monthYearPicker').val(current.toISOString().split("T")[0]);
            build30DayCarousel(current);
        }
    });
    
    $('#next30').on('click', function () {
        const current = new Date($('#monthYearPicker').val());
        current.setDate(current.getDate() + 7);
        $('#monthYearPicker').val(current.toISOString().split("T")[0]);
        build30DayCarousel(current);
    });
    $('body').on('click', '.selected_date', function () {
        const selectedDate = $(this).data('value');
        console.log(selectedDate);
    });
  }

  document.getElementById('triggerCalendar').addEventListener('click', function () {
    document.getElementById('monthYearPicker').showPicker?.(); // modern browsers
  });
   //Ajax Call to Populate Classes
  async function PopulateClasses(selectedDate) {
    $('#loader').show();
    $('#classSchedules').empty();
    // Convert selected date to required format (YYYY-MM-DD)
    const startDate = new Date(selectedDate).toISOString().split('T')[0];
    let startDateTime = `${startDate}`;
    let endDateTime = `${startDate}`;
     
    const token = await checkAndFetchToken(); // Fetch token before proceeding
    console.log("Token");
    console.log( token);
    // Headers from localStorage
    const headers = {
        'User-Agent': localStorage.getItem('User-Agent'),
        'Content-Type': 'application/json',
        'Api-Key': localStorage.getItem('Api-Key'),
        'Authorization': 'Bearer ' + token,
        //'Authorization': 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWJzY3JpYmVySWQiOiI1NzQyNDQ2IiwiaWQiOiI1MzgwNjg1IiwibG9naW4iOiJvcGVyYXRpb25zQGdvcGlsYXRlc3FhLmNvbSIsImFjY2VzcyI6Ik93bmVyIiwiZXhwIjoxNzQ1NTA5NDY1LCJuYmYiOjE3NDU0MjMwNjV9.fV17IKo6fVTZpMkJGSVb3iLiig77cTCYEKJts-Ruy9E',
        'SiteId': localStorage.getItem('siteId')
    };
    console.log(localStorage.getItem('tokenKey'));
    const formatDate = (date) => {
      if (typeof date === 'string') {
        date = new Date(date);
      }
      return date.toISOString().split('T')[0];
    };
    // Format dates using the function
    startDateTime = formatDate(startDateTime);
    console.log(startDateTime);
    endDateTime = formatDate(endDateTime);
    const apiUrl = `${API_BASE_URL}/classes?startDateTime=${encodeURIComponent(startDateTime)}&endDateTime=${encodeURIComponent(endDateTime)}`;

    await fetch(apiUrl, {
      method: 'GET',
      headers: headers
    })
    .then(response => {
      if (!response.ok) throw new Error("Network response was not ok");
      return response.json(); // ✅ This correctly parses the JSON response
    })
    .then(data => {
        $('#loader').hide();
        console.log("API Response:", data);

        let classes = data.Classes || []; // Updated for new API structure
        classes = classes.sort((a, b) => new Date(a.StartDateTime) - new Date(b.StartDateTime));

        if (classes.length === 0) {
          $('#classSchedules').html('<p>No classes scheduled for this day.</p>');
          return;
        }

        $('#classSchedules').empty();
        var itemcount = 0;
        classes.forEach((schedule, index) => {
          const classId = schedule.Id;
          const now = new Date();
          const classStartUTC = new Date(schedule.StartDateTime);
          const lessThanCurrentTime = classStartUTC < now;
          const classStart = new Date(classStartUTC.getTime() + (3 * 60 * 60 * 1000));

          const isSameDay = now.getFullYear() === classStart.getFullYear() &&
            now.getMonth() === classStart.getMonth() &&
            now.getDate() === classStart.getDate();

          itemcount++;
          const className = schedule.ClassDescription?.Name || 'Unknown Class';
          const classImage = 'https://app.gopilatesqatar.com/storage/'+schedule.ClassDescription?.ImageURL || 'https://via.placeholder.com/150';
          const trainerId = schedule.Staff?.Id;
          const trainerName = schedule.Staff?.Name || 'Trainer';
          const trainerBio = schedule.Staff?.Bio || ''; 
          const staffImage = 'https://app.gopilatesqatar.com/storage/'+schedule.Staff.ImageUrl || 'https://via.placeholder.com/400';
          const trainerImage = schedule.Staff?.ImageUrl || staffImage;
          const available = lessThanCurrentTime ? "Closed" : (schedule.IsAvailable ? "Available" : "Waitlist Open");
          const bookedStatus = schedule.TotalBooked + '/' + schedule.MaxCapacity;

          const startDateTimeStr = schedule.StartDateTime;
          console.log(schedule.StartDateTime);
          const startDate = new Date(startDateTimeStr);
          const startTime = startDate.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
            timeZone: 'UTC'  // prevent local time conversion
          });
          
          let endDate;
          let durationMinDisplay = 50;
          if (schedule.EndDateTime) {
            const end = new Date(schedule.EndDateTime);
            const durationInMinutes = (end - startDate) / 60000;
            if (durationInMinutes < 60) {
              durationMinDisplay = durationInMinutes;
              endDate = end;
            } else {
              endDate = new Date(startDate.getTime() + 50 * 60000);
            }
          } else {
            endDate = new Date(startDate.getTime() + 50 * 60000);
          }

          const options = { hour: '2-digit', minute: '2-digit', hour12: true };
          
          //const startTime = startDate.toLocaleTimeString([], options);
          console.log(startTime);
          const endTime = endDate.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
            timeZone: 'UTC'  // prevent local time conversion
          });
          
          const classTime = `${startTime} - ${endTime}`;
          
          const date = new Date(startDateTimeStr);
          const weekday = date.toLocaleDateString('en-GB', { weekday: 'long' });
          const month = date.toLocaleDateString('en-GB', { month: 'long' });
          const day = date.getDate();
          const getOrdinal = (n) => {
            const s = ["th", "st", "nd", "rd"],
              v = n % 100;
            return n + (s[(v - 20) % 10] || s[v] || s[0]);
          };

          const sessionDate = `${weekday} ${getOrdinal(day)} ${month}`;
          const actionBtn = lessThanCurrentTime
            ? `<button class="btn btn-secondary btn-lg w-100" type="button" disabled>
                  CLOSED <i class="bi bi-lock-fill"></i>
              </button>`
            : (schedule.IsWaitlistAvailable
              ? `<button class="btn btn-warning btn-lg w-100" type="button"
                    onclick="JoinWaitList(${schedule.Id}, true, ${schedule.Program.Id})">
                    <span class="spinner-border spinner-border-sm me-2 d-none" role="status" aria-hidden="true"></span>
                    JOIN WAITLIST <i class="bi bi-hourglass-split"></i>
                </button>`
              : `<button class="btn btn-primary btn-lg w-100" type="button"
                    onclick="BookClass(${schedule.Id}, false, ${schedule.Program.Id})"
                    style="background: #051958;">
                    <span class="spinner-border spinner-border-sm me-2 d-none" role="status" aria-hidden="true"></span>
                    BOOK NOW <i class="bi bi-chevron-right"></i>
                </button>`
            );

          const bgcolorclass = lessThanCurrentTime ? 'bg-disable' : '';
          const textcolorclass = lessThanCurrentTime ? 'text-dark' : '';

          $('#classSchedules').append(`
            <div class="scheduleitem col-12 mb-1" style="border-bottom: 1px solid #cfcfcf;" data-bs-toggle="offcanvas" data-bs-target="#offcanvasSchedule_${index}" aria-controls="offcanvasSchedule_${index}">
              <div class="row p-2 ${bgcolorclass}">
                <div class="col-8">
                  <h6 class="classtitle ${textcolorclass}" style="font-weight:700;">${className}</h6>
                  <span class="badge badge-light text-bg-secondary" style="border:2px solid;">${available}</span><br/>
                  <p class="font-bold font-12" style="font-size: 0.9rem;">
                    <i class="bi bi-clock"></i> ${durationMinDisplay}mins <i class="bi bi-person"></i> ${trainerName}<br/>
                  </p>
                   <p class="font-bold font-12" style="font-size: 0.9rem;">
                      <i class="bi bi-bar-chart-fill"></i>  <b>${schedule.ClassDescription?.Level || 'All Levels.'}</b></p>
                </div>
                <div class="col-4 d-flex align-items-center justify-content-center">
                  <div class="avatar avatar-100 coverimg me-2 mb-3 position-relative" style="background-image: url('${classImage}'); background-size: cover; background-position: center;">
                    <div class="overlay-text position-absolute bottom-0 start-0 w-100 text-white text-center p-1" style="background: rgba(0, 0, 0, 0.6); font-size: 14px;">
                      ${startTime}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="offcanvas offcanvas-bottom" tabindex="-1" id="offcanvasSchedule_${index}" aria-labelledby="offcanvasBottomLabel" style="height: 100vh;">
              <div class="offcanvas-header text-center">
                <button class="btn btn-square btn-link" data-bs-dismiss="offcanvas" aria-label="Close">
                  <i class="bi bi-chevron-left"></i>
                </button>
                <div class="col-10"><img src="assets/img/go-logo.svg" width="50px;"></div>
              </div>
              <div class="offcanvas-body">
                <div class="alert-container"></div>
                <div class="row">
                  <div class="col-12 col-md-4 col-lg-3 mb-2">
                    <figure class="w-100 height-240 position-relative m-0">
                      <img src="${classImage}" alt="" class="img-fluid w-100 h-100" style="object-fit: cover;">
                      <div class="position-absolute top-0 end-0 m-2 px-2 py-1 bg-dark text-white rounded small" style="font-size: 13px;">
                        ${bookedStatus} Booked
                      </div>
                      <div class="position-absolute bottom-0 start-0 w-100 text-white text-center p-2" style="background: rgba(0, 0, 0, 0.5); font-size: 14px;">
                        <h5 class="mb-0">${className}</h5>
                      </div>
                    </figure>
                  </div>
                  <div class="col-12 col-md-12 col-lg-12">
                    <div class="mb-3 text-center">
                      <button class="btn btn-sm btn-outline-theme me-1 border_bottom mx-auto mb-2 ">
                        <i class="bi bi-clock-fill"></i><b> Date : &nbsp;  ${sessionDate} </b><b><br/> Time:  ${classTime}</b>
                      </button>
                    </div>
                    <div class="mb-3 border_bottom">
                      <i class="bi bi-person-workspace"></i> <b>TRAINER</b>
                      <div class="col-auto text-center mb-4">
                        <div class="avatar avatar-300 rounded-circle me-2 mb-3"
                            style=" background-image: url('${staffImage}'); background-size: cover; background-position: center;">
                            <img class="w-auto" src="${staffImage}" alt="">
                        </div>
                        
                        <div class="card card-body">
                        <p class="text-secondary mb-2"><b>${trainerName}</b></p>
                        ${trainerBio}</div>
                      </div>
                    </div>
                    <div class="mb-3 border_bottom">
                      <i class="bi bi-bar-chart-fill"></i> <b>LEVEL</b>
                      <p class="text-secondary"><b>${schedule.ClassDescription?.Level || 'All Levels'}</b></p>
                    </div>
                    <div class="mb-3">
                      <i class="bi bi-card-checklist"></i> <b>DESCRIPTION</b>
                      <p class="text-secondary justify-content pb-2" style="text-align: justify;">
                        ${schedule.ClassDescription?.Description || 'No description available.'}
                      </p>
                    </div>
                    <div class="mb-3">
                      <i class="bi bi-card-checklist"></i> <b>POLICIES</b>
                      <p class="text-secondary justify-content pb-2" style="text-align: justify;">
                        <strong>Arriving to Class:</strong> We recommend arriving at least 5 minutes before your class or private. Late arrival may lead to forfeiting your reserved spot.
                        Clients must accept full responsibility for any discomfort or reduced effectiveness resulting from late arrival. Safety and class flow are priorities.
                      </p>
                      <p class="text-secondary justify-content pb-2" style="text-align: justify;">
                        <strong>New Clients:</strong> Arrive 10 minutes early for an introduction. Late arrival may result in denied entry for safety.
                        <strong>Injuries:</strong> Inform instructors of any issues before class. Consult a doctor if needed.
                      </p>
                      <p class="text-secondary justify-content pb-2" style="text-align: justify;">
                        <strong>Pregnant Clients:</strong> Must get clearance from healthcare provider and inform staff. Entry may be denied without clearance.
                      </p>
                      <p class="text-secondary justify-content pb-2" style="text-align: justify;">
                        <strong>No Cell Phones:</strong> Avoid distractions during class. Leave if there's an emergency. Respect others.
                      </p>
                      <p class="text-secondary justify-content pb-2" style="text-align: justify;">
                        <strong>Cancellation Policy:</strong> Cancel via the app: 3 hours before group class, 12 hours before private. Late cancellation results in full charge.
                      </p>
                      <p class="text-secondary justify-content pb-2" style="text-align: justify;">
                        <strong>Refunds:</strong> All sales are final. Non-refundable and non-transferable.
                      </p>
                      <p class="text-secondary justify-content pb-2" style="text-align: justify;">
                        <strong>Waitlist:</strong> Join if a class is full. Notification sent if a spot opens. Walk-ins welcome depending on availability.
                      </p>
                      <p class="text-secondary justify-content pb-2" style="text-align: justify;">
                        <strong>Grip Socks:</strong> Recommended for hygiene and safety. Available for purchase at the studio.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="position-fixed bottom-0 start-0 w-100 bg-white p-3 border-top text-center">
                ${actionBtn}
              </div>
            </div>
          `);
        });

        if (itemcount < 1) {
          $('#classSchedules').append(
            `<div class="scheduleitem col-12 pt-2 mb-1" style="border-bottom: 1px solid #cfcfcf; background-color: #f6f4f4;">
              <div class="row">
                <div class="col-12">
                  <p class="h6"> No Classes Available to Book for Today! </p>
                </div>
              </div>`
          );
        }
      })
    .catch(error => {
        console.error("Error fetching class schedules:", error);
        $('#loader').hide();
        $('#classSchedules').html('<p>Error loading schedule. Please try again.</p>');
    });   
  }
let allServices = []; // Store all services globally
let activeType = "Class"; // Default tab

window.LoadPackages = async function (classId = null) {
  $('#loader').show();
  try {
    // Build the base URL
    let apiUrl = `${API_BASE_URL}/packages`;

    // If a classId is provided, add it as a query parameter
    if (classId !== null) {
      apiUrl += `?class_id=${classId}`;
    }

    const res = await fetch(apiUrl);
    const data = await res.json();
    $('#loader').hide();
    if (data.message === "success" && data.details?.Services?.length) {
      allServices = data.details.Services;
      renderServicesByType(activeType);
    }
  } catch (err) {
    $('#loader').hide();
    console.error("Failed to load packages:", err);
  }
};

function renderServicesByType(type) {
  const filteredServices = allServices.filter(service => service.Type === type);
  const container = document.getElementById("packagesContainer");
  container.innerHTML = '';
  var client_id = localStorage.getItem('clientId')?.replace(/^"|"$/g, '');

  filteredServices.forEach((service, index) => {
    const bgClass = service.Program === "Privates" ? "bg-gradient-6" : "bg-gradient-7";
    const icon = service.Program === "Privates"
      ? `<i class="bi bi-person-fill"></i> Private Session`
      : `<i class="bi bi-people-fill"></i> ${service.Program}`;
    
    const card = document.createElement("div");
    card.className = `card adminuiux-card mb-4 ${bgClass}`;
    card.innerHTML = `
      <div class="card-header">
        <div class="row align-items-center">
          <div class="col border_bottom">
            <h6 class="text-primary text-center">${service.Name}</h6>
            ${icon}
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="table-responsive mb-1">
          <table class="table">
            <thead>
              <tr><th scope="col">TOTAL</th><th scope="col">PRICE</th></tr>
            </thead>
            <tbody>
              <tr><th scope="row">${service.Count || 1}</th><td class="PackPrice_${service.Id}" data-value="${service.OnlinePrice}">${service.OnlinePrice} ر.ق</td></tr>
            </tbody>
          </table>
        </div>

        <button class="btn btn-light mb-2 d-flex justify-content-between align-items-center" type="button" data-bs-toggle="collapse" data-bs-target="#collapseDetails${index}" aria-expanded="false" aria-controls="collapseDetails${index}">
          <span>View Details</span> <i class="bi bi-chevron-down rotate-icon" id="chevron${index}"></i>
        </button>

        <div class="promo-section my-2" id="promoSection_${service.Id}" style="display: none;">
          <input type="text" class="form-control mb-2" placeholder="Enter promo code (optional)" id="promoInput_${service.Id}">
          <input type="hidden" class="form-control mb-2"  value="${service.Id}" id="promoService_${service.Id}">
          <div id="promoError_${service.Id}" class="text-danger small mb-2" style="display: none;"></div>
          <button class="btn btn-primary mb-2 d-flex justify-content-between align-items-center" type="button" onclick="ApplyPromoBox(${service.Id})">
            Apply Promo
          </button>
        </div>

        <button class="btn btn-light mb-2 d-flex justify-content-between align-items-center" type="button" onclick="togglePromoBox(${service.Id})">
          Have a promo code?
        </button>

        <div class="collapse mb-2" id="collapseDetails${index}">
          <div class="details">
            <small>
              - Valid for ${service.ExpirationLength} ${service.ExpirationUnit.toLowerCase()}(s) from date of purchase<br/>
              - Non-refundable<br/>
              - Cancellation policy: 3 hours prior to class<br/>
              - Usage allowed at locations: ${service.UseAtLocationIds?.join(', ') || 'N/A'}<br/>              
             - Teen from 13Yrs till 17Yrs are allowed to come only in teen classes. <br/>   
            </small>
          </div>
        </div>

        <button class="btn btn-primary w-100" type="button" id="paymentinitiate_${service.Id}" style="background: #051958;" onClick="InitiatePayment(${service.Id}, ${client_id}, ${service.OnlinePrice});">
          Buy this credit pack <i class="bi bi-chevron-right"></i>
        </button>
        <div id="paymentButtonSadad_${service.Id}"></div>
      </div>
    `;
    container.appendChild(card);
  });
}

document.querySelectorAll('#packageTabs .nav-link').forEach(tab => {
  tab.addEventListener('click', function (e) {
    e.preventDefault();
    document.querySelectorAll('#packageTabs .nav-link').forEach(t => t.classList.remove('active'));
    this.classList.add('active');
    activeType = this.getAttribute('data-type');
    renderServicesByType(activeType);
  });
});

window.togglePromoBox = function(serviceId) {
  const promoBox = document.getElementById(`promoSection_${serviceId}`);
  promoBox.style.display = promoBox.style.display === 'none' ? 'block' : 'none';
}

window.ApplyPromoBox = function(serviceId) {
  const promoInput = document.getElementById(`promoInput_${serviceId}`);
  const promoService = document.getElementById(`promoService_${serviceId}`);
  const promoError = document.getElementById(`promoError_${serviceId}`);
  const promoCode = promoInput?.value.trim();
  const promoServiceValue = promoService?.value.trim();
  const clientId = localStorage.getItem('clientId')?.replace(/^"|"$/g, '');

  // Clear previous error
  promoError.style.display = 'none';
  promoError.innerText = '';

  if (!promoCode || !clientId) {
    promoError.innerText = !promoCode ? 'Please enter a promo code.' : 'Client ID not found.';
    promoError.style.display = 'block';
    return;
  }

  $.ajax({
    url: `${API_BASE_URL}/check-promo-usage`,
    method: 'POST',
    contentType: 'application/json',
    data: JSON.stringify({
      client_id: clientId,
      promo_code: promoCode,
      service_id:promoServiceValue
    }),
    success: function (response) {
      console.log("Promo API Response:", response);

      if (response.status === 1) {
        let originalPrice = parseFloat($(`.PackPrice_${serviceId}`).data('value'));
        let finalPrice = originalPrice;
        console.log(originalPrice);
        if (response.type === 'Percent') {
          finalPrice = originalPrice - (originalPrice * (response.amount / 100));
        } else if (response.type === 'Amount') {
          finalPrice = originalPrice - response.amount;
        }
        console.log(finalPrice);
        finalPrice = Math.max(finalPrice, 0);
        // Update buy button onclick
        const payBtn = document.getElementById(`paymentinitiate_${serviceId}`);
        if (payBtn) {
          payBtn.setAttribute('onclick', `InitiatePayment(${serviceId}, ${clientId}, ${finalPrice.toFixed(2)}, '${promoCode}')`);
        }

        showAlert(`Promo applied! Final price: QAR ${finalPrice.toFixed(2)}`, 'success');
        $(`#promoError_${serviceId}`).text(`Promo applied! Final price: QAR ${finalPrice.toFixed(2)}`);
        promoError.style.display = 'block';
        // Save discount info for later use or directly call payment
        //InitiatePayment(serviceId, clientId, finalPrice);
      } else {
        promoError.innerText = response.message || 'Invalid promo code.';
        promoError.style.display = 'block';
        $(`#promoError_${serviceId}`).text(response.message).show();
      }
    },
    error: function () {
      promoError.innerText = 'Error validating promo code. Please try again.';
      promoError.style.display = 'block';
    }
  });
}

//MY PACKAGES
window.LoadMypackages = async function (){
  const clientId = localStorage.getItem('clientId')?.replace(/^"|"$/g, '');
  const token = await checkAndFetchToken();
  console.log(localStorage.getItem('clientId'));
  if (!clientId) {
      console.warn("clientId not found in localStorage.");
      return;
  }
  

  const container = document.getElementById('myPackagesContainer');
  container.innerHTML = '<p class="text-center">Loading packages...</p>';
  $('#loader').show();
  // Adjust to your proxy URL
  fetch(`${API_BASE_URL}/client/complete-info?client_id=${clientId}`)
      .then(response => response.json())
      .then(data => {
        $('#loader').hide();
        console.log(data);
        const container = document.getElementById("myPackagesContainer");
        container.innerHTML = ""; // Clear existing

        const services = data.ClientServices || [];
        console.log(services);
        if (services.length === 0) {
            container.innerHTML = `
                <div class="text-center mt-4">
                    <p>You don't have any active packs. Please purchase one.</p>
                    <a  class="btn btn-primary btn-lg w-100"  data-bs-toggle="offcanvas" data-bs-target="#PackageOffCanvas" aria-controls="PackageOffCanvas">Buy Packages</a>
                </div>
            `;
            return; // Exit early
        }
        services.forEach((service, index) => {
            const programName = service?.Name || "Unknown Program";
            const bgClass = programName === "Privates" ? "bg-gradient-6" : "bg-gradient-7";
            const icon = programName === "Privates"
                ? `<i class="bi bi-person-fill"></i> Private Session`
                : `<i class="bi bi-people-fill"></i> ${programName}`;

            const card = document.createElement("div");
            card.className = `card adminuiux-card mb-4 ${bgClass}`;
            card.innerHTML = `
                <div class="card-header">
                    <div class="row align-items-center">
                        <div class="col border_bottom">
                            <h6 class="text-primary text-center">${service.Name}</h6>
                            ${icon}
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive mb-1">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th scope="col">TOTAL</th>
                                    <th scope="col">REMAINING</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>${service.TotalSessions || 1}</td>
                                    <td>${service.RemainingSessions}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    
                    <button class="btn btn-light mb-2 d-flex justify-content-between align-items-center" 
                            type="button" 
                            data-bs-toggle="collapse" 
                            data-bs-target="#collapsePackageDetails${index}" 
                            aria-expanded="false" 
                            aria-controls="collapsePackageDetails${index}">
                        <span>View Details</span>
                        <i class="bi bi-chevron-down rotate-icon" id="chevron${index}"></i>
                    </button>
                    <div class="collapse mb-2" id="collapsePackageDetails${index}">
                        <div class="details">
                            <small>
                                - Valid from: ${new Date(service.StartDate).toLocaleDateString()}<br/>
                                - Expires on: ${new Date(service.EndDate).toLocaleDateString()}<br/>
                                - Program: ${programName}<br/>
                                - Non-refundable<br/>
                                - Cancellation policy: ${service.Program?.CancelOffset || 0} hours prior<br/>
                            </small>
                        </div>
                    </div>

                    
                </div>
            `;
            container.appendChild(card);
          });
          
      })
      .catch(error => {
          console.error('Error fetching services:', error);
          container.innerHTML = '<p class="text-danger text-center">Error loading packages.</p>';
      });
      
}
window.parseAsQatarLocal = function(isoLike) {
  if (!isoLike) return null;
  let s = String(isoLike).trim();

  // If it ends with 'Z', replace with '+03:00' (we're treating that UTC stamp as Qatar local)
  s = s.replace(/Z$/i, '+03:00');

  // If it has no offset, append '+03:00'
  if (!/[+-]\d{2}:\d{2}$/.test(s)) {
    s += '+03:00';
  }

  return new Date(s); // now this Date is the correct instant for "that local Qatar wall time"
}
// Build "X Days Y Hours From Now" badge for future events
window.buildFutureBadge = function(diffMs) {
  if (diffMs <= 0) return '';
  const totalHours = Math.round(diffMs / (1000 * 60 * 60)); // nearest hour
  const days = Math.floor(totalHours / 24);
  const hours = totalHours % 24;

  let label;
  if (days > 0) {
    const d = `${days} ${days === 1 ? 'Day' : 'Days'}`;
    const h = hours > 0 ? ` ${hours} ${hours === 1 ? 'Hour' : 'Hours'}` : '';
    label = d + h;
  } else {
    label = `${hours} ${hours === 1 ? 'Hour' : 'Hours'}`;
  }

  return `
    <span class="badge badge-sm badge-light text-bg-theme-1 theme-cyan">
      <i class="bi bi-patch-check-fill"></i> ${label} From Now
    </span>`;
}

window.toBoolean = function(val) {
  // Treat "true", "1", 1, true as true; "false", "0", 0, null, undefined, "" as false
  if (typeof val === 'boolean') return val;
  if (typeof val === 'number') return val !== 0;
  if (typeof val === 'string') {
    const s = val.trim().toLowerCase();
    if (s === 'true' || s === '1' || s === 'yes') return true;
    if (s === 'false' || s === '0' || s === 'no' || s === '') return false;
  }
  return Boolean(val);
}

//LOAD MY BOOKINGS
window.LoadUpcomingBookings = async function () {
  const clientId = localStorage.getItem('clientId')?.replace(/^"|"$/g, '');
  const token = await checkAndFetchToken();
  const container = document.getElementById('MyUpComingBookings'); 
  
  container.innerHTML = '<p class="text-center">Loading bookings...</p>';

  if (!clientId) {
      console.warn("clientId not found.");
      container.innerHTML = '<p class="text-danger text-center">Client not found.</p>';
      return;
  }

  const startDate = new Date().toISOString().split('T')[0] + 'T00:00:00';
  const endDate = new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0] + 'T23:59:00';
  $('#loader').show();
  fetch(`${API_BASE_URL}/client/bookings?client_id=${clientId}&&status=upcoming`)
      .then(res => res.json())
      .then(data => {
        $('#loader').hide();
          container.innerHTML = '';

          const visits = data.data || [];

          if (!visits.length) {
              container.innerHTML = '<p class="text-center">No upcoming bookings.</p>';
              return;
          } 
          // Qatar formatters
          const qatarDateFmt = new Intl.DateTimeFormat('en-GB', {
            day: '2-digit', month: 'long', year: 'numeric', timeZone: 'Asia/Qatar'
          });
          const qatarTimeFmt = new Intl.DateTimeFormat('en-US', {
            hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Qatar'
          });

          let BookingsHtml = '';
          visits.forEach((visit, i) => {
              // 1) Parse as QATAR local wall time -> correct absolute instant
              const start = parseAsQatarLocal(visit.start_datetime);
              const end   = parseAsQatarLocal(visit.end_datetime);

              // 2) Format in Asia/Qatar
              const dateStr   = qatarDateFmt.format(start);
              const startTime = qatarTimeFmt.format(start);
              const endTime   = qatarTimeFmt.format(end);

              // 3) Compute diff vs *now* (instantaneous); timezone doesn’t matter for the diff
              const diffMs = start.getTime() - Date.now();

              // 4) Badge + cancel rule (>= 3 hours ahead, not attended)
              const timeBadge = buildFutureBadge(diffMs);
              const THREE_HOURS_MS = 3 * 60 * 60 * 1000;               
              const attended = toBoolean(visit.attended);
              const timediff = toBoolean(diffMs >= THREE_HOURS_MS);               
              const canCancel = (attended == false) && (timediff == true);
              
              // 5) Buttons by status
              let cancelBtn = '';
              if (visit.status === 'booked') {
                cancelBtn = canCancel
                  ? `<button class="btn btn-sm btn-link bg-danger text-white" onclick="CancelBooking(${visit.booking_id})">
                      <i class="bi bi-x-circle me-1"></i> CANCEL
                    </button>`
                  : '';
              } else if (visit.status === 'cancelled') {
                cancelBtn = `<button class="btn btn-sm btn-link bg-secondary text-white" disabled>
                              <i class="bi bi-x-circle me-1"></i> CANCELLED
                            </button>`;
              }

              // 6) Card UI
              const imgIndex = (i % 3) + 1;
              const isCancelled = visit.status === 'cancelled';
              const cardBg = isCancelled ? 'style="background:#cfcfcf"' : '';

              BookingsHtml += `
                <div class="card adminuiux-card style-none mb-3" ${cardBg}>
                  <div class="card-body">
                    <p class="mb-3 small fw-medium text-secondary">
                      ${dateStr} - ${startTime} - ${endTime} <span class="text-warning bi bi-tag"></span>
                    </p>
                    <div class="row align-items-center gx-2 mb-0">
                      <div class="col-auto">
                        <img src="assets/img/fitness/image-${imgIndex}.jpg" class="avatar avatar-40 rounded" alt="">
                      </div>
                      <div class="col">
                        <h6 class="mb-0">${visit.class_name || 'Unnamed Class'}</h6>
                        <p class="text-secondary small text-truncated">
                          ${timeBadge}
                          <br/> ${cancelBtn}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              `;
            });

          container.innerHTML = BookingsHtml;
      })
      .catch(err => {
          console.error("Error loading bookings:", err);
          container.innerHTML = '<p class="text-danger text-center">Error loading bookings.</p>';
      });
}


$(document).ready(function () { 
  $('.MyPackagesMenu').click(function(){
    LoadMypackages();
    
  });
  $('.MyUpcomingBookingsMenu').click(function(){
    LoadUpcomingBookings();    
  });
  $('.MyWaitListMenu').click(function(){
    LoadClientWaitlistEntries();    
  });
  $('.MyPaymentsMenu').click(function(){
    LoadPayments();    
  });
  $('#LoadPackagesMenu').click(function(){
    localStorage.removeItem("BookClassId");
    localStorage.removeItem("BookWaitlist");
    LoadPackages();    
  });
  //Ajax Call to Populate Classes
  $(document).ready(function () {
      const today = new Date();
      const localDateStr = today.getFullYear() + '-' + 
          String(today.getMonth() + 1).padStart(2, '0') + '-' + 
          String(today.getDate()).padStart(2, '0');
      
     
      PopulateClasses(localDateStr);
  });


    let pollingInterval;
    function CheckPaymentStatus(id, order_id) {
        $('#SadadSubmitBtn_' + id).hide();
        $('#paymentStatus_' + id).show();
    
        function fetchStatus() {
            $.ajax({
                url: `http://localhost:8000/api/payment/status/${order_id}`,
                type: 'GET',
                dataType: 'json',
                success: function(response) {
                    if (response && typeof response === 'object' && Object.keys(response).length > 0) {
                        const tableHtml = `
                            <table class="table table-bordered mt-2">
                                <tr><th>Order ID</th><td>${response.order_id}</td></tr>
                                <tr><th>MID</th><td>${response.MID}</td></tr>
                                <tr><th>Response Code</th><td>${response.RESPCODE}</td></tr>
                                <tr><th>Response Message</th><td>${response.RESPMSG}</td></tr>
                                <tr><th>Status</th><td>${response.STATUS}</td></tr>
                                <tr><th>Transaction Amount</th><td>${response.TXNAMOUNT}</td></tr>
                                <tr><th>Transaction Number</th><td>${response.transaction_number}</td></tr>
                                <tr><th>Transaction Status</th><td>${response.transaction_status}</td></tr>
                                <tr><th>Website Ref No</th><td>${response.website_ref_no}</td></tr>
                            </table>
                        `;
                        $('#paymentStatus_' + id).html(tableHtml);
    
                        // Stop polling on success or failure
                        if (response.STATUS === "TXN_SUCCESS" || response.STATUS === "TXN_FAILURE") {
                            clearInterval(pollingInterval);
                        }
                    }
                    // else: do nothing if response is null
                },
                error: function() {
                    console.error('Failed to fetch payment status.');
                }
            });
        }
    
        // Call once immediately
        fetchStatus();
    
        // Set interval to call every 10 seconds
        pollingInterval = setInterval(fetchStatus, 10000);
    }

     
    $(document).ready(function() {
    // Toggle password visibility
    $('.toggle-password').click(function() {
      const input = $(this).siblings('.form-floating').find('input');
      const icon = $(this).find('i');
      
      if (input.attr('type') === 'password') {
        input.attr('type', 'text');
        icon.removeClass('bi-eye').addClass('bi-eye-slash');
      } else {
        input.attr('type', 'password');
        icon.removeClass('bi-eye-slash').addClass('bi-eye');
      }
    });
  
    // Switch to register form
    $('.show-register').click(function(e) {      
      e.preventDefault();
      $('#loginSection').hide();
      $('#registerSection').show();
      $('#namef').focus();
      $('#forgotPasswordSection').hide();
      $('#forgotStep1').hide();
      $('#forgotStep2, #forgotStep3').hide();
    });
  
    // Switch to login form
    $('.show-login').click(function(e) {
      e.preventDefault();
      $('#registerSection').hide();
      $('#loginOTPSection').hide();
      $('#loginSection').show();
      $('#emailadd').focus();
      $('#forgotPasswordSection').hide();
      $('#forgotStep1').hide();
      $('#forgotStep2, #forgotStep3').hide();
    });
    
    $('.show-loginotp').click(function(e) {
      e.preventDefault();
      $('#registerSection').hide();
      $('#loginOTPSection').show();
      $('#loginOTPStep1Email').hide();
      $('#loginOTPStep1').show();
      $('#loginSection').hide();
      $('#emailadd').focus();
      $('#forgotPasswordSection').hide();
      $('#forgotStep1').hide();
      $('#forgotStep2, #forgotStep3').hide();
      $('#sendOtpBtn1').html("Send OTP");
    });

    $('.show-loginemail').click(function(e) {
      e.preventDefault();
      $('#registerSection').hide();
      $('#loginOTPSection').show();
      $('#loginOTPStep1Email').show();
      $('#loginOTPStep1').hide();
      $('#loginSection').hide();
      $('#emailadd').focus();
      $('#forgotPasswordSection').hide();
      $('#forgotStep1').hide();
      $('#forgotStep2, #forgotStep3').hide();
      $('#sendOtpBtn1').html("Send OTP");
    });
    
     
    // Password strength checker (optional)
    $('#regPassword').on('input', function() {
      // Implement your password strength logic here
    });

    // Show Forgot Password
    $('.forgot-password').click(function(e) {
      e.preventDefault();
      $('#loginSection, #registerSection').hide();
      $('#forgotPasswordSection').show();
      $('#forgotStep1').show();
      $('#forgotStep2, #forgotStep3').hide();
    });

    // Send OTP
    $('#sendOtpBtn').click(function() {
      const phone = $('#forgotPhone').val().trim();
      if (!phone) {
        showAlert('Please enter your phone number', 'danger');
        return;
      }

      $(this).html('<span class="spinner-border spinner-border-sm"></span> Sending...');

      fetch(`${API_BASE_URL}/otp/request`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json','Accept': 'application/json' },
        body: JSON.stringify({ identifier: phone, is_login: 0 })
      })
      .then(response => response.json())
      .then(data => {
        if (data.message == 'OTP sent successfully.') {
          showAlert('OTP sent successfully!', 'success');
          localStorage.setItem('forgotPhone', phone); // Save phone
          $('#forgotStep1').hide();
          $('#forgotStep2').show();
        } else {
          showAlert(data.message || 'Failed to send OTP', 'danger');
        }
      })
      .catch(error => {
        console.error('OTP Request Error:', error);
        showAlert('Something went wrong.', 'danger');
      })
      .finally(() => {
        $('#sendOtpBtn').html('Send OTP');
      });
    });

     
    $('#sendOtpBtn1').click(function() {
      const phone = $('#otpphonen').val().trim();
      if (!phone) {
        showAlert('Please enter your phone number', 'danger');
        return;
      }
      $(this).html('<span class="spinner-border spinner-border-sm"></span> Sending...');

      fetch(`${API_BASE_URL}/otp/request`, {
        method: 'POST',
         headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                        // 'Authorization': `Bearer ${yourApiToken}` // add this if required
                    },
        body: JSON.stringify({ login: phone, is_login: 1, login_type:'phone' }),
        credentials: 'omit' // IMPORTANT: 'omit' or just remove this line if you're not using cookies
      })
      .then(response => response.json())
      .then(data => {
        if(data.message == 'User not found.'){
          showAlert('User not found. Please Register Account', 'danger');           
          $('#loginOTPSection').hide();
          $('#loginSection').hide();
          $('#registerSection').show();
          $('#namef').focus();
          $('#forgotPasswordSection').hide();
          $('#forgotStep1').hide();
          $('#forgotStep2, #forgotStep3').hide();

        }else if (data.message == 'OTP sent successfully.') {
          showAlert('OTP sent successfully!', 'success');
          localStorage.setItem('OTPPhone', phone); // Save phone
          $('#loginOTPStep1').hide();
          $('#loginOTPStep2').show();
        } else {
          showAlert(data.message || 'Failed to send OTP', 'danger');
        }
      })
      .catch(error => {
        console.error('OTP Request Error:', error);
        showAlert('Something went wrong.', 'danger');
      })
      .finally(() => {
        $('#sendOtpBtn').html('Send OTP');
      });
    });

    $('#sendOtpBtn1Email').click(function() {
      const email = $('#otpemail').val().trim();
      if (!email) {
        showAlert('Please enter your email address', 'danger');
        return;
      }
      // Basic email format validation
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(email)) {
          showAlert('Please enter a valid email address', 'danger');
          return;
      }
      $(this).html('<span class="spinner-border spinner-border-sm"></span> Sending...');

      fetch(`${API_BASE_URL}/otp/request`, {
        method: 'POST',
         headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                        // 'Authorization': `Bearer ${yourApiToken}` // add this if required
                    },
        body: JSON.stringify({ login: email, is_login: 1, login_type:'email' }),
        credentials: 'omit' // IMPORTANT: 'omit' or just remove this line if you're not using cookies
      })
      .then(response => response.json())
      .then(data => {
        if(data.message == 'User not found.'){
          showAlert('User not found. Please Register Account', 'danger');           
          $('#loginOTPSection').hide();          
          $('#loginSection').hide();
          $('#registerSection').show();
          $('#namef').focus();
          $('#forgotPasswordSection').hide();
          $('#forgotStep1').hide();
          $('#forgotStep2, #forgotStep3').hide();

        }else if (data.message == 'OTP sent successfully.') {
          showAlert('OTP sent successfully!', 'success');
          localStorage.setItem('OTPPhone', email); // Save phone
          $('#loginOTPStep1').hide();
          $('#loginOTPStep1Email').hide();
          $('#loginOTPStep2').show();
        } else {
          showAlert(data.message || 'Failed to send OTP', 'danger');
        }
      })
      .catch(error => {
        console.error('OTP Request Error:', error);
        showAlert('Something went wrong.', 'danger');
      })
      .finally(() => {
        $('#sendOtpBtn').html('Send OTP');
      });
    });

    // Verify OTP
    $('#verifyOtpBtn').click(function() {
      const otp = $('#otpCode').val().trim();
      const phone = localStorage.getItem('forgotPhone');

      if (!otp) {
        showAlert('Please enter OTP', 'danger');
        return;
      }

      $(this).html('<span class="spinner-border spinner-border-sm"></span> Verifying...');

      fetch(`${API_BASE_URL}/otp/verify`, {
        method: 'POST',
         headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                        // 'Authorization': `Bearer ${yourApiToken}` // add this if required
                    },
        body: JSON.stringify({ login: phone, otp: otp })
      })
      .then(response => response.json())
      .then(data => {
        if (data.message == 'OTP verified.') {
          showAlert('OTP verified successfully!', 'success');
          $('#forgotStep2').hide();
          $('#forgotStep3').show();
        } else {
          showAlert(data.message || 'Invalid OTP', 'danger');
        }
      })
      .catch(error => {
        console.error('OTP Verify Error:', error);
        showAlert('Something went wrong.', 'danger');
      })
      .finally(() => {
        $('#verifyOtpBtn').html('Verify OTP');
      });
    });

    $('#verifyOtpBtn1').click(function() {
      const otp = $('#otpCode1').val().trim();
      const phone = localStorage.getItem('OTPPhone');

      if (!otp) {
        showAlert('Please enter OTP', 'danger');
        return;
      }

      $(this).html('<span class="spinner-border spinner-border-sm"></span> Verifying...');

      fetch(`${API_BASE_URL}/otp/verify`, {
        method: 'POST',
         headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                        // 'Authorization': `Bearer ${yourApiToken}` // add this if required
                    },
        body: JSON.stringify({ login: phone, otp: otp })
      })
      .then(response => response.json())
      .then(data => {
        if (data.status == 'success' && data.token) {
          console.log(data);
          showAlert('OTP verified successfully!', 'success');
          $('#loginOTPSection').hide();
          localStorage.setItem('LoggedDate', new Date().toISOString());
          localStorage.setItem('isLoggedIn', 'true');
          localStorage.setItem('authToken', data.token);
          localStorage.setItem('siteId', 5742446);
          localStorage.setItem('Test', false);
          localStorage.setItem('User-Agent', 'MobileApp');
          localStorage.setItem('Api-Key', '82b0c00f5b804ac0b5ac2e5b2870a3e1');
          localStorage.setItem('userData', JSON.stringify(data.user || data.data));
          localStorage.setItem('clientId', JSON.stringify(data.user.user_identifier));
          localStorage.setItem('mindbodyUserData', JSON.stringify(data.user_identifier));
          localStorage.setItem('ProfileName', data.user.name);
          localStorage.setItem('name', data.user.name);
          localStorage.setItem('email', data.user.email);
          localStorage.setItem('phone', data.user.phone);    
          console.log(localStorage.getItem('clientId'));    
          $('#ProfileName').html(data.user.name);
          $('#authOverlay').hide();
          $('#mainContent').show();
          initializeCalendar();localStorage.setItem('isLoggedIn', 'true');
          localStorage.setItem('authToken', data.token);
          localStorage.setItem('siteId', 5742446);
          localStorage.setItem('Test', false);
          localStorage.setItem('User-Agent', 'MobileApp');
          localStorage.setItem('Api-Key', '82b0c00f5b804ac0b5ac2e5b2870a3e1');
          localStorage.setItem('userData', JSON.stringify(data.user || data.data));
          localStorage.setItem('clientId', JSON.stringify(data.user.user_identifier));
          localStorage.setItem('mindbodyUserData', JSON.stringify(data.user_identifier));
          localStorage.setItem('ProfileName', data.user.name);
          localStorage.setItem('name', data.user.name);
          localStorage.setItem('email', data.user.email);
          localStorage.setItem('phone', data.user.phone);
    
          console.log(localStorage.getItem('clientId'));
    
          $('#ProfileName').html(data.user.name);
          $('#authOverlay').hide();
          $('#mainContent').show();
          initializeCalendar();
          
        } else {
          showAlert(data.message || 'Invalid OTP', 'danger');
        }
      })
      .catch(error => {
        console.error('OTP Verify Error:', error);
        showAlert('Something went wrong.', 'danger');
      })
      .finally(() => {
        $('#verifyOtpBtn1').html('Verify OTP');
      });
    });

    // Reset Password
    $('#resetPasswordBtn').click(function() {
      const newPassword = $('#newPassword').val();
      const confirmPassword = $('#confirmNewPassword').val();
      const phone = localStorage.getItem('forgotPhone');
      const otp = $('#otpCode').val().trim();

      if (!newPassword || !confirmPassword) {
        showAlert('Please fill all password fields', 'danger');
        return;
      }
      if (newPassword !== confirmPassword) {
        showAlert('Passwords do not match', 'danger');
        return;
      }

      $(this).html('<span class="spinner-border spinner-border-sm"></span> Resetting...');

      fetch(`${API_BASE_URL}/otp/reset-password`, {
        method: 'POST',
         headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                        // 'Authorization': `Bearer ${yourApiToken}` // add this if required
                    },
        body: JSON.stringify({
          login: phone,
          otp: otp,
          password: newPassword,
          password_confirmation: confirmPassword
        })
      })
      .then(response => response.json())
      .then(data => {
        if (data.message == 'Password reset successful.') {
          showAlert('Password reset successfully!', 'success');
          // After reset, go back to login
          $('#forgotPasswordSection').hide();
          $('#loginSection').show();
        } else {
          showAlert(data.message || 'Failed to reset password', 'danger');
        }
      })
      .catch(error => {
        console.error('Reset Password Error:', error);
        showAlert('Something went wrong.', 'danger');
      })
      .finally(() => {
        $('#resetPasswordBtn').html('Reset Password');
      });
    });

    

  }); 
    
});
async function getHeaders(){
  const token = await checkAndFetchToken(); // Fetch token before proceeding
  console.log("Token");
  console.log( token);
  // Headers from localStorage
  const headers = {
      'User-Agent': localStorage.getItem('User-Agent'),
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Api-Key': localStorage.getItem('Api-Key'),
      'Authorization': 'Bearer ' + token,
      //'Authorization': 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWJzY3JpYmVySWQiOiI1NzQyNDQ2IiwiaWQiOiI1MzgwNjg1IiwibG9naW4iOiJvcGVyYXRpb25zQGdvcGlsYXRlc3FhLmNvbSIsImFjY2VzcyI6Ik93bmVyIiwiZXhwIjoxNzQ1NTA5NDY1LCJuYmYiOjE3NDU0MjMwNjV9.fV17IKo6fVTZpMkJGSVb3iLiig77cTCYEKJts-Ruy9E',
      'SiteId': localStorage.getItem('siteId')
  };
  return headers;
}
window.BookClass = async function (classId, waitlist, programId) {
  localStorage.setItem("BookClassId", classId);
  localStorage.removeItem("BookWaitlist");
  $('#loader').show();
  const clientId = localStorage.getItem('clientId')?.replace(/^"|"$/g, '');
  const headers = getHeaders(); //Fetch token before proceeding
  try {
      const response = await fetch(`${API_BASE_URL}/client/complete-info?client_id=${clientId}`, {
          method: 'GET',
          headers: headers
      });

      const data = await response.json();
      $('#loader').hide();

      const services = data.ClientServices || [];
      console.log("ClientServices");
      console.log(services);
      // const matchedService = services.find(service =>
      //   service.Program?.Id === programId && service.Remaining > 0
      // );
      // Only find matched service if programId is not '30'
      let matchedService = null;
      let canbook = false;
      console.log("Program" + programId);
      if (programId != '1') {
        matchedService = services.find(service =>
            service.Programs?.some(p => p.Id == programId) && service.RemainingSessions > 0
        );

        if (!matchedService) {
            showAlert("No matching package found or your sessions are exhausted. Please buy a new package.", "warning");
            closeCurrentOffCanvas();
            setTimeout(() => openPackageOffCanvas(classId), 500);
            return;
        }

        if (matchedService.RemainingSessions < 1) {
            showAlert("You don't have remaining sessions. Please buy a new package.", "warning");
            closeCurrentOffCanvas();
            setTimeout(() => openPackageOffCanvas(classId), 500);
            return;
        }

        canbook = true;
      } else {
          canbook = true;
      }
      if(canbook == true){
                // Proceed with booking
                $('#loader').show();
                console.log(headers);
                const bookResponse = await fetch(`${API_BASE_URL}/book-class`, {
                  method: 'POST',
                   headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                        // 'Authorization': `Bearer ${yourApiToken}` // add this if required
                    },
                    body: JSON.stringify({
                        client_id: clientId,
                        class_id: classId,                        
                        wait_list: waitlist || false                        
                    })
                });

                const result = await bookResponse.json();
                console.log(result);
                $('#loader').hide();
                if (result.status == 'error') {
                    showAlert(result.message, "success");
                    closeCurrentOffCanvas();
                    const $offcanvas = $('#BookingsOffCanvas');
                    const offcanvasInstance = bootstrap.Offcanvas.getOrCreateInstance($offcanvas[0]);
                    offcanvasInstance.show();
                    LoadUpcomingBookings(); 
                }else if (bookResponse.ok && result.status == 'success') {
                    showAlert("Class successfully booked!", "success");
                    closeCurrentOffCanvas();
                    const $offcanvas = $('#BookingsOffCanvas');
                    const offcanvasInstance = bootstrap.Offcanvas.getOrCreateInstance($offcanvas[0]);
                    offcanvasInstance.show();
                    LoadUpcomingBookings(); 
                } else {
                    console.error(result);
                    showAlert("Failed to book the class. Please try again.", "danger");
                }
      }

  } catch (error) {
      $('#loader').hide();
      console.error('Error in booking process:', error);
      showAlert("Something went wrong. Please try again.", "danger");
  }
};

window.JoinWaitList = async function (classId, waitlist = true, programId) {
  localStorage.setItem("BookClassId", classId);
  localStorage.setItem("BookWaitlist", 1);
  console.log("JoinWaitList called with:", classId, waitlist);
  $('#loader').show();

  const clientId = localStorage.getItem('clientId')?.replace(/^"|"$/g, '');
  const headers = getHeaders(); // Custom function to return headers
   
  try {
    // Step 1: Get client service info
    const response = await fetch(`${API_BASE_URL}/client/complete-info?client_id=${clientId}`, {
      method: 'GET',
      headers: headers
    });

    const data = await response.json();
    $('#loader').hide();

    const services = data.ClientServices || [];
    // const matchedService = services.find(service =>
    //   service.Program?.Id === programId && service.Remaining > 0
    // );
    // Only find matched service if programId is not '1'
      let matchedService = null;
      //alert(programId);
      let canbook = false;
      console.log("Program" + programId);
      // Helper: safely get remaining sessions from either field
      const getRemaining = (service) =>
        Number(service?.RemainingSessions ?? service?.Remaining ?? 0);

      // Normalize programId (in your sample you compare against 1 as a number)
      const pid = Number(programId);

      if (pid !== 1) {
        const hasProgramMatch = (service) => {
          // Supports both Programs[] and a legacy Program object if it ever appears
          if (Array.isArray(service?.Programs)) {
            return service.Programs.some(p => Number(p?.Id) === pid);
          }
          return Number(service?.Program?.Id) === pid; // fallback
        };

        matchedService = (Array.isArray(services) ? services : []).find(service =>
          hasProgramMatch(service) && getRemaining(service) > 0
        );

        if (!matchedService) {
          showAlert(
            "No matching service/package found for this class or your sessions are exhausted. Please purchase a package for the class.",
            "warning"
          );
          closeCurrentOffCanvas();
          setTimeout(() => openPackageOffCanvas(classId), 500);
          return;
        }

        if (getRemaining(matchedService) < 1) {
          showAlert(
            "You don't have remaining sessions. Please buy a new package.",
            "warning"
          );
          closeCurrentOffCanvas();
          setTimeout(() => openPackageOffCanvas(classId), 500);
          return;
        }

        canbook = true;
      } else {
        // pid === 1: allow booking (as per your original logic)
        canbook = true;
      }
      if(canbook == true){
        // Step 2: Proceed to join waitlist
        $('#loader').show();
        const waitlistResponse = await fetch(`${API_BASE_URL}/book-class`, {
          method: 'POST',
          headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                        // 'Authorization': `Bearer ${yourApiToken}` // add this if required
                    },
          body: JSON.stringify({
            client_id: clientId,
            class_id: classId,
            // Test: false,
            // RequirePayment: false,
            wait_list: true
            // SendEmail: true
          })
        });

        const result = await waitlistResponse.json();
        $('#loader').hide();
        if(result.status == 'error'){
          closeCurrentOffCanvas();       
          // Now open BookingsOffCanvas
          const $bookingsOffCanvas = $('#BookingsOffCanvas');
          const bsCanvas = bootstrap.Offcanvas.getOrCreateInstance($bookingsOffCanvas[0]);
          bsCanvas.show();
          LoadUpcomingBookings(); 
          showAlert(result.message, "success");
        }
        else if (waitlistResponse.ok && result.status == 'success') {  
          closeCurrentOffCanvas();       
          // Now open BookingsOffCanvas
          const $bookingsOffCanvas = $('#BookingsOffCanvas');
          const bsCanvas = bootstrap.Offcanvas.getOrCreateInstance($bookingsOffCanvas[0]);
          bsCanvas.show();
          LoadUpcomingBookings(); 
          showAlert("Successfully added to the waitlist!", "success");
        } else {
          const errorMessage = result?.Error?.Message || "Could not join the waitlist. Please try again.";
          console.error("Waitlist error:", result);
          showAlert(errorMessage, "danger");
        }
      }
  } catch (error) {
    $('#loader').hide();
    console.error('Error while joining waitlist:', error);
    showAlert("Something went wrong while trying to join the waitlist.", "danger");
  }
};
window.LoadClientWaitlistEntries = async function () {
  const clientId = localStorage.getItem('clientId')?.replace(/^"|"$/g, '');
  const headers = await getHeaders(); // assumes you already have this function
  const container = document.getElementById('ClientWaitlistEntries'); 
  
  container.innerHTML = '<p class="text-center">Loading waitlist...</p>';

  if (!clientId) {
      console.warn("clientId not found.");
      container.innerHTML = '<p class="text-danger text-center">Client not found.</p>';
      return;
  }

  $('#loader').show();
  console.log(headers);
  fetch(`${API_BASE_URL}/client/waitlist?client_id=${clientId}`, {
      method: 'GET',
      headers: headers
  })
  .then(res => res.json())
  .then(data => {
      $('#loader').hide();

      container.innerHTML = ''; // clear any existing content

      const waitlistEntries = data.data || [];

      if (!waitlistEntries.length) {
          container.innerHTML = '<p class="text-center">No waitlist entries found.</p>';
          return;
      }

      let WaitlistHtml = '';
      waitlistEntries.forEach((entry, i) => {
          // const start = new Date(entry.ClassDate);
          // const dateStr = start.toLocaleDateString('en-GB', {
          //     day: '2-digit',
          //     month: 'long',
          //     year: 'numeric'
          // });

          // const startTime = start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
          // Extract and format ClassDate
          const classDate = new Date(entry.start_datetime);
          const dateStr = classDate.toLocaleDateString('en-GB', {
              day: '2-digit',
              month: 'long',
              year: 'numeric',
              timeZone: 'UTC'
          });

          // Extract and format StartTime (time-only string)
          const startTime = new Date(entry.start_datetime).toLocaleTimeString([], {
              hour: '2-digit',
              minute: '2-digit',
              hour12: true,
              timeZone: 'UTC'
          });

          const imgIndex = i % 3 + 1; // for rotating image-1 to image-3
          const requestDate = new Date(entry.joined_at);
          const readableDate = requestDate.toLocaleString('en-GB', {
              day: '2-digit',
              month: 'long',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              hour12: true,
              
          });
          WaitlistHtml += `
              <div class="card adminuiux-card style-none mb-3">
                  <div class="card-body">
                      <p class="mb-3 small fw-medium text-secondary">${dateStr} - ${startTime} <span class="text-warning bi bi-tag"></span></p>
                      <div class="row align-items-center gx-2 mb-0">
                          <div class="col-auto"><img src="https://app.gopilatesqatar.com/storage/${entry.class_image}" class="avatar avatar-40 rounded" alt=""></div>
                          <div class="col">
                              <h6 class="mb-0">${entry.class_name || 'Unnamed Class'}</h6>
                              <p class="text-secondary small text-truncated">
                                  <span class="badge badge-light text-bg-primary">Joined On:  ${readableDate}</span>
                              </p>
                          </div>
                      </div>
                  </div>
              </div>
          `;
      });

      container.innerHTML = WaitlistHtml;
  })
  .catch(err => {
      console.error("Error loading waitlist entries:", err);
      container.innerHTML = '<p class="text-danger text-center">Error loading waitlist entries.</p>';
  });
};

window.LoadPayments = function () {
  const client_id = localStorage.getItem('clientId')?.replace(/^"|"$/g, '');
  const url = `${API_BASE_URL}/clientpayments/`+client_id;
  fetch(url)
    .then(response => response.json())
    .then(paymentData => {
      const container = document.getElementById("paymentHistoryContainer");
      container.innerHTML = '';

      if (!paymentData || paymentData.length === 0) {
        container.innerHTML = 'No payments made';
        return;
      }

      paymentData.forEach(entry => {
        const bgClass = entry.status === "paid" ? "bg-success-subtle" : "bg-light";
        const textClass = entry.status === "paid" ? "text-success" : "text-warning";

        const card = `
          <div class="card adminuiux-card border-0 ${bgClass} mb-3">
            <div class="card-body">
              <div class="row gx-3">
                <div class="col-12">
                  <p>
                    <span class="badge badge-sm ${textClass} bg-white border">${entry.status.toUpperCase()}</span>
                  </p>
                  <h6 class="${textClass} mb-1">Order ID: ${entry.order_id}</h6>
                  <p class="small mb-1">Amount: <strong>${entry.amount} ${entry.currency}</strong></p>
                  ${entry.package_name ? `<p class="small mb-1">Package: ${entry.package_name} (${entry.package_type || 'N/A'})</p>` : ''}
                  ${entry.program ? `<p class="small mb-1">Program: ${entry.program}</p>` : ''}
                  ${entry.transaction_id ? `<p class="small mb-1">Txn ID: <strong>${entry.transaction_id}</strong></p>` : ''}
                  ${entry.response_msg ? `<p class="small mb-1">Message: ${entry.response_msg}</p>` : ''}
                  ${entry.date ? `<p class="small mb-0">Date: ${entry.date}</p>` : ''}
                </div>
              </div>
            </div>
          </div>
        `;

        container.innerHTML += card;
      });
    })
    .catch(error => {
      document.getElementById("paymentHistoryContainer").innerHTML = `<div class="alert alert-danger">Failed to load payment history.</div>`;
      console.error("Error fetching data:", error);
    });
};


 
// Function to close the current offcanvas
function closeCurrentOffCanvas() {
  // Assuming you're using Bootstrap's offcanvas
  const currentOffcanvas = document.querySelector('.offcanvas.show');
  if (currentOffcanvas) {
      const offcanvasInstance = bootstrap.Offcanvas.getInstance(currentOffcanvas);
      offcanvasInstance.hide();
      // Manually remove backdrop (if it persists)
      const backdrop = document.querySelector('.offcanvas-backdrop');
      $('.offcanvas').removeClass('show');
      $('.offcanvas-backdrop').removeClass('show');
      $('.offcanvas-backdrop').remove();
      $('body').removeClass('offcanvas-backdrop').css('overflow', '');
      if (backdrop) {
          backdrop.remove();  // Remove the backdrop element
      }
  }
}
window.addEventListener('popstate', function () {
  // Hide all open offcanvas elements
  const openOffcanvas = document.querySelector('.offcanvas.show');
  if (openOffcanvas) {
      const instance = bootstrap.Offcanvas.getInstance(openOffcanvas);
      if (instance) instance.hide();
  }

  // Remove leftover backdrop manually (fallback)
  document.querySelectorAll('.offcanvas-backdrop').forEach(backdrop => backdrop.remove());

  // Remove body overflow
  document.body.classList.remove('offcanvas-backdrop', 'modal-open', 'overflow-hidden');
});
// Function to open the PackageOffCanvas
function openPackageOffCanvas(classId = null) {  
  const packageOffCanvas = new bootstrap.Offcanvas(document.getElementById('PackageOffCanvas'));
  packageOffCanvas.show();
  LoadPackages(classId);
}

// Function to show alert with dynamic message
window.showAlert = function(message, type = "warning") {
  // Create alert HTML
  const alertBox = document.createElement('div');
  alertBox.classList.add('alert', `alert-${type}`, 'alert-dismissible', 'fade', 'show');
  alertBox.setAttribute('role', 'alert');

  // Create strong text inside alert
  const strongText = document.createElement('strong');
  strongText.textContent = "Alert: ";

  const textNode = document.createTextNode(message);
  alertBox.appendChild(strongText);
  alertBox.appendChild(textNode);

  // Create dismiss button
  const closeButton = document.createElement('button');
  closeButton.classList.add('btn-close');
  closeButton.setAttribute('type', 'button');
  closeButton.setAttribute('data-bs-dismiss', 'alert');
  closeButton.setAttribute('aria-label', 'Close');

  alertBox.appendChild(closeButton);

  // Append the alert box to the body or a specific container
  document.body.appendChild(alertBox);

  // Optional: Automatically remove alert after 5 seconds
  setTimeout(() => {
      alertBox.remove();
  }, 10000);
}

function toggleBookNowLoader($button, show = true) {
  const $spinner = $button.find('.spinner-border');
  $spinner.toggleClass('d-none', !show);
  $button.prop('disabled', show);
}

window.CancelBooking = async function (visitId) {
   
  if (!visitId) {
      showAlert("Visit ID missing.", "danger");
      return;
  }

  if (!confirm("Are you sure you want to cancel this booking?")) return;

  $('#loader').show();
  const headers = await getHeaders(); // Reuse your existing auth header generator
  console.log(headers);
  checkAndFetchToken().then(token => {      

      fetch(`${API_BASE_URL}/bookings/cancel-early`, {
          method: 'POST',
          headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                        // 'Authorization': `Bearer ${yourApiToken}` // add this if required
                    },
          body: JSON.stringify({
              visit_id: visitId,
              // Execute: "Cancel"
          })
      })
      .then(res => res.json())
      .then(data => {
          $('#loader').hide();
          if (data&& data.status == 'success') {
              showAlert("Booking successfully cancelled.", "success");
              // Optionally reload the bookings
              LoadUpcomingBookings();
          }else if (data&& data.status == 'error') {
              showAlert(data.message, "success");
              // Optionally reload the bookings
              LoadUpcomingBookings();
          } else {
              console.warn("Cancel response:", data);
              showAlert("Failed to cancel booking. Please try again.", "danger");
          }
      })
      .catch(err => {
          $('#loader').hide();
          console.error("Error cancelling booking:", err);
          showAlert("Something went wrong while cancelling the booking.", "danger");
      });
  });
}

$(document).on('click', '.AccountButton', async function () {
  const clientId = localStorage.getItem('clientId')?.replace(/^"|"$/g, '');

  if (!clientId) {
      alert("Client ID not found.");
      return;
  }

  const token = await checkAndFetchToken();
  const headers = getHeaders();
  $('#loader').show(); // show loader if needed

  fetch(`${API_BASE_URL}/client/complete-info?client_id=${clientId}`, {
      headers: headers
  })
      .then(res => res.json())
      .then(data => {
          $('#loader').hide();

          const client = data.Client;
          const balance = client?.AccountBalance ?? 0.0;
          const phone = client?.MobilePhone ?? 'N/A';
          const email = client?.Email ?? 'N/A';
          const name = client?.FirstName + ' ' + client?.LastName;

          // Populate values into elements by IDs
          $('#accountBalance').text(`QR ${balance}`);
          $('#clientPhone').text(phone);
          $('#clientEmail').text(email);
          $('.clientName').text(name);
      })
      .catch(err => {
          $('#loader').hide();
          console.error("Error fetching account details:", err);
          alert("Failed to load account information.");
      });
});

    //InitiatePayment
window.InitiatePayment = function(id, client_id, amount, promocode=''){  
    let book_class_id =null;    
    if (localStorage.getItem("BookClassId")) {
      book_class_id = localStorage.getItem("BookClassId");
      // use id
    } 
    let book_waitlist = 0;    
    if (localStorage.getItem("BookWaitlist")) {
      book_waitlist = 1;
      // use id
    } 
      $.ajax({
          url: `${API_BASE_URL}/initiate-payment`,
          method: 'POST',
          contentType: 'application/json',
          data: JSON.stringify({
              amount: amount,
              client_id: client_id,
              package_id: id,
              class_id: book_class_id,
              wait_list: book_waitlist,
              promo_code: promocode
          }),
          success: function (response) {
              if (response.status === 'success' && response.payment_data) {
                  const d = response.payment_data;

                  // Build the Sadad form dynamically
                  let sadadForm = `
                      <form method="POST" action="https://sadadqa.com/webpurchase" id="sadadForm_${id}">
                          <input type="hidden" name="CALLBACK_URL" value="${d.CALLBACK_URL}">
                          <input type="hidden" name="EMAIL" value="${d.EMAIL}">
                          <input type="hidden" name="MOBILE_NO" value="${d.MOBILE_NO}">
                          <input type="hidden" name="ORDER_ID" value="${d.ORDER_ID}">
                          <input type="hidden" name="SADAD_WEBCHECKOUT_PAGE_LANGUAGE" value="${d.SADAD_WEBCHECKOUT_PAGE_LANGUAGE}">
                          <input type="hidden" name="TXN_AMOUNT" value="${d.TXN_AMOUNT}">
                          <input type="hidden" name="WEBSITE" value="${d.WEBSITE}">
                          <input type="hidden" name="merchant_id" value="${d.merchant_id}">
                          <input type="hidden" name="txnDate" value="${d.txnDate}">
                          <input type="hidden" name="signature" value="${d.signature}">
                          <input type="hidden" name="productdetail[0][order_id]" value="${d.productdetail[0].order_id}">
                          <input type="hidden" name="productdetail[0][amount]" value="${d.productdetail[0].amount}">
                          <input type="hidden" name="productdetail[0][quantity]" value="${d.productdetail[0].quantity}">
                          <button type="submit" class="btn btn-success w-100 mt-3" id="SadadSubmitBtn_${id}">Proceed to Online Payment</button>
                      </form>
                  `;

                  // Replace the button with new form
                  $('#paymentinitiate_'+id).hide();
                  $('#paymentButtonSadad_'+id).html(sadadForm);
                  $('#SadadSubmitBtn_'+id).click(function(){ 
                  });
                  
              } else {
                  alert('Payment initiation failed. Please try again.');
              }
          },
          error: function (xhr) {
              console.error(xhr);
              alert('An error occurred. Please try again.');
          }
      }); 
}

//Show Alert
window.showAlert = function(message, type = 'success') {
  console.log("showAlert Called");
  const alertHtml = `
      <div class="alert alert-${type} alert-dismissible fade show mt-2" role="alert">
          <strong>${type === 'success' ? 'Success' : 'Notice'}:</strong> ${message}
          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>`; 
   // Apply alert to all alert-container elements (inside offcanvas or elsewhere)
  document.querySelectorAll('.alert-container').forEach(container => {
    container.innerHTML = alertHtml;
  });

  // Optional: Auto-dismiss after 5 seconds
  setTimeout(() => {
    document.querySelectorAll('.alert').forEach(alert => {
      alert.classList.remove('show');
      setTimeout(() => alert.remove(), 300); // Wait for fade-out
    });
  }, 8000); 
}


;(() => {
  const STORAGE_KEY = 'cpaAccepted_v1';
  const IDs = {
    modal: 'cpaModal',
    modalLabel: 'cpaModalLabel',
    terms: 'cpaTerms',
    modalCheckbox: 'cpaModalCheckbox',
    acceptBtn: 'cpaAcceptBtn',
    inlineWrap: 'cpaInlineWrap',
    inlineCheckbox: 'cpaInlineCheckbox',
    status: 'cpaStatus',
  };

  const log = (...a) => console.log('[CPA]', ...a);
  const accepted = () => localStorage.getItem(STORAGE_KEY) === '1';
  const hasBootstrap = () => !!(window.bootstrap && window.bootstrap.Modal);

  function ensureModalInjected() {
    if (document.getElementById(IDs.modal)) return;
    if (!hasBootstrap()) { log('Bootstrap not found (window.bootstrap.Modal missing)'); return; }

    const html = `
<div class="modal fade" id="${IDs.modal}" tabindex="-1" aria-labelledby="${IDs.modalLabel}" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg"><div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="${IDs.modalLabel}">Client Participation Agreement & Liability Waiver</h5>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
    <div class="modal-body p-0">
      <div id="${IDs.terms}" class="p-3" style="max-height:50vh;overflow:auto">
        <h6 class="mb-3">GO Pilates Sports and Wellness Center<br>Client Participation Agreement & Liability Waiver</h6>
        <p>This agreement is between GO Pilates Sports and Wellness Center (“Studio”) and the undersigned client (“Participant”). By signing below or otherwise participating in any activity, the Participant agrees to the following terms:</p>
        <p><strong>1. Assumption of Risk</strong><br>At GO Pilates Studio, our sessions are thoughtfully designed to challenge and energize you. While our certified instructors prioritize safety, any physical activity inherently involves a risk of injury. By joining a class or using our facilities, you acknowledge and accept this potential risk and voluntarily assume full responsibility for any injury, loss, or damage that may occur.</p>
        <p><strong>2. Personal Responsibility & Liability Waiver</strong><br>I understand and agree that I am fully responsible for any injury or health condition that may occur while participating in classes, using the studio’s equipment, or being present on the premises. I hereby waive, release, and discharge GO Pilates Sports and Wellness Center, its owners, instructors, employees, and affiliates from any and all liability, claims, demands, or causes of action arising from or related to any injury, illness, or damage that may result from my participation.</p>
        <p><strong>3. Age Requirement</strong><br>I affirm that I am 18 years of age or older and legally competent to sign this agreement. (If under 18, a parent or legal guardian must sign on behalf of the minor.)</p>
        <p><strong>4. Medical Clearance</strong><br>I affirm that I am physically fit to participate in exercise activities or have consulted a medical professional prior to starting. I will listen to my body, make necessary modifications, and ask instructors for guidance when needed.</p>
        <p><strong>5. Use of Studio & Equipment</strong><br>I agree to use all studio equipment and spaces responsibly, showing respect for others and the environment. I will adhere to posted guidelines and follow staff directions to ensure a safe experience for everyone.</p>
        <p><strong>6. Code of Conduct</strong><br>I commit to treating fellow members and staff with respect and kindness. Any form of harassment, discrimination, or disruptive behavior will result in appropriate action, which may include suspension or termination of membership.</p>
        <p><strong>7. Membership Terms</strong></p>
        <ul>
          <li>All memberships and class packages are non-refundable.</li>
          <li>Each package and membership has a limited validity period, clearly stated at the time of purchase (and on the mobile application).</li>
          <li>Freezing of memberships is not permitted, except for VIP memberships.</li>
          <li>Cancellations: must be made at least 3 hours before the scheduled class.</li>
        </ul>
        <p><em>Unlimited Memberships:</em> If canceled within 3 hours of class time, and this happens twice, online booking will be restricted — future bookings must be made at the reception in person.</p>
        <p><em>Session-Based Packages:</em> If canceled late, one session will be deducted from the package.</p>
        <p><strong>8. Emergency Protocols</strong><br>In case of an emergency, I agree to follow all instructions from staff and cooperate fully with evacuation or safety procedures.</p>
        <p><strong>9. Personal Belongings</strong><br>I understand that GO Pilates Studio is not responsible for loss or theft of personal belongings on the premises.</p>
        <p><strong>10. Governing Law</strong><br>This agreement shall be governed by the laws of the State of Qatar, and any disputes shall be resolved under its jurisdiction.</p>
      </div>
      <div class="border-top p-3">
        <div class="form-check mb-2">
          <input class="form-check-input" type="checkbox" id="${IDs.modalCheckbox}" disabled>
          <label class="form-check-label" for="${IDs.modalCheckbox}">I have read the entire agreement and I accept the terms.</label>
        </div>
        <div class="d-flex gap-2 justify-content-end">
          <button type="button" class="btn btn-link" data-bs-dismiss="modal">Close</button>
          <button type="button" class="btn btn-theme btn_theme" id="${IDs.acceptBtn}" disabled>Accept & Continue</button>
        </div>
      </div>
    </div>
  </div></div>
</div>`;
    document.body.insertAdjacentHTML('beforeend', html);

    const modalEl = document.getElementById(IDs.modal);
    const terms = document.getElementById(IDs.terms);
    const mcb = document.getElementById(IDs.modalCheckbox);
    const acceptBtn = document.getElementById(IDs.acceptBtn);

    modalEl.addEventListener('shown.bs.modal', () => {
      terms.scrollTop = 0;
      mcb.checked = false;
      mcb.disabled = true;
      acceptBtn.disabled = true;
    });

    terms.addEventListener('scroll', () => {
      const atBottom = Math.ceil(terms.scrollTop + terms.clientHeight) >= terms.scrollHeight;
      if (atBottom && mcb.disabled) mcb.disabled = false;
    });

    mcb.addEventListener('change', () => {
      acceptBtn.disabled = !mcb.checked;
    });

    acceptBtn.addEventListener('click', () => {
      localStorage.setItem(STORAGE_KEY, '1');
      reflectAcceptanceInline();
      const inst = bootstrap.Modal.getOrCreateInstance(modalEl);
      inst.hide();
    });

    // Ghost-backdrop cleanup
    modalEl.addEventListener('hidden.bs.modal', () => {
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('padding-right');
      document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
    });

    log('Modal injected');
  }

  function ensureInlineInjected() {
    if (document.getElementById(IDs.inlineWrap)) return;

    const reg = document.getElementById('registerSection');
    if (!reg) { log('registerSection not found'); return; }

    // Anchor only inside Register: regConfirmPassword exists there
    const confirm = reg.querySelector('#regConfirmPassword');
    if (!confirm) { log('regConfirmPassword not found inside registerSection'); return; }

    const host = confirm.closest('.position-relative') || confirm;
    const wrap = document.createElement('div');
    wrap.id = IDs.inlineWrap;
    wrap.className = 'mb-3';
    wrap.innerHTML = `
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="${IDs.inlineCheckbox}" disabled>
        <label class="form-check-label" for="${IDs.inlineCheckbox}">
          I accept the <a href="#" id="openCpaModalLink">Client Participation Agreement</a>
        </label>
      </div>
      <div class="small mt-1">Status: <span id="${IDs.status}" class="badge bg-secondary">Not accepted</span></div>
    `;
    host.parentNode.insertBefore(wrap, host.nextSibling);

    document.getElementById('openCpaModalLink').addEventListener('click', (e) => {
      e.preventDefault();
      const inst = bootstrap.Modal.getOrCreateInstance(document.getElementById(IDs.modal));
      inst.show();
    });

    log('Inline block injected');
  }

  function reflectAcceptanceInline() {
    const cb = document.getElementById(IDs.inlineCheckbox);
    const status = document.getElementById(IDs.status);
    const regBtn = document.getElementById('registerBtn');

    if (cb) cb.checked = true;
    if (status) { status.textContent = 'Accepted'; status.classList.replace('bg-secondary', 'bg-success'); }
    if (regBtn) regBtn.disabled = false;
  }

  function enforceRegisterGuard() {
    const regBtn = document.getElementById('registerBtn');
    if (!regBtn) return;

    regBtn.disabled = !accepted();

    $(regBtn).off('click.cpaGuard').on('click.cpaGuard', function (e) {
      if (accepted()) return; // let your real handler run
      e.stopImmediatePropagation();
      e.preventDefault();
      bootstrap.Modal.getOrCreateInstance(document.getElementById(IDs.modal)).show();
      if (window.showAlert) window.showAlert('Please read and accept the Client Participation Agreement to continue.', 'warning');
      else alert('Please accept the Client Participation Agreement to continue.');
      return false;
    });
  }

  function observeRegisterSection() {
    const reg = document.getElementById('registerSection');
    if (!reg) return;

    const resync = () => {
      ensureInlineInjected();
      enforceRegisterGuard();
      if (accepted()) reflectAcceptanceInline();
      else {
        const b = document.getElementById('registerBtn');
        if (b) b.disabled = true;
      }
    };

    const mo = new MutationObserver(() => setTimeout(resync, 0));
    mo.observe(reg, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });

    // also when you click “Create Account”
    $(document).on('click', '.show-register', () => setTimeout(resync, 0));
  }

  function boot() {
    ensureModalInjected();
    ensureInlineInjected();
    observeRegisterSection();
    enforceRegisterGuard();
    if (accepted()) reflectAcceptanceInline();
    log('Init complete');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

// ---- CPA scroll gate hardening patch ----
;(() => {
  const modalEl = document.getElementById('cpaModal');
  const terms   = document.getElementById('cpaTerms');
  const gateCb  = document.getElementById('cpaModalCheckbox');
  const accept  = document.getElementById('cpaAcceptBtn');

  if (!modalEl || !terms || !gateCb || !accept) return;

  // Tolerate zoom/rounding by a couple of px
  const AT_BOTTOM_PAD = 2;

  function atBottom() {
    return (terms.scrollTop + terms.clientHeight) >= (terms.scrollHeight - AT_BOTTOM_PAD);
  }

  function updateGate() {
    // If no scroll is possible (content fits), enable immediately
    const fits = terms.scrollHeight <= terms.clientHeight + AT_BOTTOM_PAD;
    if (fits || atBottom()) {
      gateCb.disabled = false;
    }
  }

  // Reset each time the modal opens, then immediately check if we should enable
  modalEl.addEventListener('shown.bs.modal', () => {
    terms.scrollTop = 0;
    gateCb.checked = false;
    gateCb.disabled = true;
    accept.disabled = true;
    // Check right away in case content fits without scroll
    setTimeout(updateGate, 0);
  });

  // Consider all ways users can reach bottom
  terms.addEventListener('scroll', updateGate);
  terms.addEventListener('wheel', updateGate, { passive: true });
  terms.addEventListener('touchmove', updateGate, { passive: true });
  window.addEventListener('resize', updateGate);

  // Keyboard navigation inside modal (End / PageDown etc.)
  modalEl.addEventListener('keydown', () => setTimeout(updateGate, 0));

  // Enable Accept only when box is checked
  gateCb.addEventListener('change', () => {
    accept.disabled = !gateCb.checked;
  });
})();

/* ===== CPA Accept wiring + close + main form update (final patch) ===== */
;(() => {
  const STORAGE_KEY = 'cpaAccepted_v1';

  function applyAcceptance() {
    // re-query each time in case Register UI was rebuilt
    const inlineCb   = document.getElementById('cpaInlineCheckbox');
    const statusEl   = document.getElementById('cpaStatus');
    const registerBtn= document.getElementById('registerBtn');

    localStorage.setItem(STORAGE_KEY, '1');

    if (inlineCb) inlineCb.checked = true;
    if (statusEl) {
      statusEl.textContent = 'Accepted';
      statusEl.classList.remove('bg-secondary');
      statusEl.classList.add('bg-success');
    }
    if (registerBtn) registerBtn.disabled = false;
  }

  function wireAccept() {
    const modalEl    = document.getElementById('cpaModal');
    const acceptBtn  = document.getElementById('cpaAcceptBtn');
    const gateCb     = document.getElementById('cpaModalCheckbox');

    if (!modalEl || !acceptBtn) return;
    const inst = window.bootstrap?.Modal.getOrCreateInstance(modalEl);

    // (Re)bind click with a namespace so duplicates don’t pile up
    $(acceptBtn).off('click.cpaAccept').on('click.cpaAccept', function (e) {
      e.preventDefault();
      applyAcceptance();
      inst?.hide();
    });

    // Safety: if user closes the modal after checking the box, still apply
    modalEl.addEventListener('hide.bs.modal', () => {
      if (gateCb?.checked) applyAcceptance();

      // Ghost backdrop cleanup
      setTimeout(() => {
        document.body.classList.remove('modal-open');
        document.body.style.removeProperty('padding-right');
        document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
      }, 10);
    });
  }

  // Wire now, and wire again whenever Register is revealed (your UI toggles)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireAccept);
  } else {
    wireAccept();
  }
  $(document).on('click', '.show-register', () => setTimeout(wireAccept, 0));
})();
